import { Container, Row, Col, Form } from "react-bootstrap";
import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaPen,
  FaDollarSign,
  FaGlobe,
  FaBuilding,
  FaWhatsapp,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoMdBuild } from "react-icons/io";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { IoLogoWhatsapp } from "react-icons/io";
import Footer from "../Footer/Footer";
import "../../assets/css/contact.css";
import { useNavigate } from "react-router-dom";

const ContactForm = () => {
  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const mapRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const initMap = () => {
      if (!mapRef.current) return;

      const location = { lat: 51.5074, lng: -0.1278 };

      const map = new window.google.maps.Map(mapRef.current, {
        zoom: 13,
        center: location,
        mapTypeId: "roadmap",
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
        ],
      });

      const marker = new window.google.maps.Marker({
        position: location,
        map: map,
        title: "Riverside Building, County Hall",
        icon: {
          url:
            "data:image/svg+xml;charset=UTF-8," +
            encodeURIComponent(`
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 2C10.48 2 6 6.48 6 12C6 20 16 30 16 30S26 20 26 12C26 6.48 21.52 2 16 2ZM16 16C13.79 16 12 14.21 12 12S13.79 8 16 8S20 9.79 20 12S18.21 16 16 16Z" fill="#EF4444"/>
            </svg>
          `),
          scaledSize: new window.google.maps.Size(32, 32),
          anchor: new window.google.maps.Point(16, 32),
        },
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding: 12px; font-family: 'Inter', sans-serif;">
            <h6 style="margin: 0 0 8px 0; color: #1F2937; font-size: 16px; font-weight: 600;">Riverside Building</h6>
            <p style="margin: 0; color: #6B7280; font-size: 14px;">County Hall, Westminster Bridge Rd<br>London SE1 7JA, UK</p>
          </div>
        `,
      });

      marker.addListener("click", () => {
        infoWindow.open(map, marker);
      });
    };

    if (!window.google) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&loading=async&callback=initMap`;
      script.async = true;
      script.defer = true;
      window.initMap = initMap;
      document.head.appendChild(script);
    } else {
      initMap();
    }

    return () => {
      if (window.initMap) {
        delete window.initMap;
      }
    };
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_z73r4mc",
        "template_evcmg1l",
        formData,
        "EscxBRJBS9wDUay2E"
      )
      .then(() => {
        alert("Enquiry sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          whatsapp: "",
          companyName: "",
          companyService: "",
          serviceType: "",
          country: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        alert("Failed to send enquiry. Try again later.");
      });
  };

  return (
    <>
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        rel="stylesheet"
      />

      <section className="position-relative min-vh-50 contact-bg d-flex align-items-center justify-content-center text-white">
        <div className="contact-content container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="/"
                      className="text-white fw-bold text-decoration-none"
                    >
                      Home
                    </a>
                  </li>
                  <li
                    className="text-white fw-bold breadcrumb-item"
                    aria-current="page"
                  >
                    Contact Us
                  </li>
                </ol>
              </nav>
              <h3 className="display-5 fw-bold mb-3">Contact Us</h3>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid py-5">
        <div className="container">
          <div className="row mb-3">
            <div className="col-12 text-center">
              <h2 className="display-4 fw-bold mb-4">
                READY TO GET MORE{" "}
                <span style={{ color: "#41C1EE" }}>INFORMATION</span>
              </h2>
              <p
                className="font-para text-center mx-auto"
                style={{ maxWidth: "800px" }}
              >
                There were twelve rules in all, and they specified that fights
                should be "a fair stand-up boxing match" in a 24-foot-square or
                similar ring. Rounds were three minutes with one-minute rest.
              </p>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="card border-white h-100 shadow-sm text-center bg-light">
                <div className="card-body">
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#41C1EE",
                      color: "white",
                    }}
                  >
                    <i
                      className="fas fa-map-marker-alt text-white"
                      style={{ fontSize: "1.4rem" }}
                    />
                  </div>
                  <h4 className="fw-bold font-black mb-3">OFFICE ADDRESS</h4>
                  <p className="font-para mb-3">
                    No. 48, 2nd Floor, Lotus Castle, First Main Rd, near Seasons
                    Seafood Restuarant, Radha Nagar, Perumbakkam, Chennai, Tamil
                    Nadu 600100
                  </p>
                  <button
                    onClick={() =>
                      window.open(
                        "https://www.google.com/maps/place/Shiv+Games+IT+Solutions+Private+Limited/@12.9090056,80.1951648,17z/data=!3m1!4b1!4m6!3m5!1s0x3a525d42a4a4febb:0x897fc6aac2adc841!8m2!3d12.9090056!4d80.1951648!16s%2Fg%2F11sx40lmrd?entry=ttu",
                        "_blank"
                      )
                    }
                    className="btn call text-white fw-semibold mt-4 px-4 py-2"
                    style={{ color: "#41C1EE", background: "#050708" }}
                  >
                    View Map
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm text-center bg-light">
                <div className="card-body">
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#41C1EE",
                    }}
                  >
                    <i
                      className="fas fa-phone text-white"
                      style={{ fontSize: "1.4rem" }}
                    />
                  </div>
                  <h4 className="fw-bold mb-3 font-black">PHONE NUMBER</h4>
                  <p className="font-para mt-3">
                    we'll reach out to you easily through your phone number :
                    +91 96550 22226
                  </p>

                  <button
                    className="btn call-now-btn text-white fw-semibold px-4 py-2 mt-5"
                    style={{ background: "#050708" }}
                    onClick={() => {
                      const section = document.getElementById("callSection");
                      section?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Call now
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm text-center bg-light">
                <div className="card-body">
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#41C1EE",
                    }}
                  >
                    <i
                      className="fas fa-envelope text-white"
                      style={{ fontSize: "1.4rem" }}
                    />
                  </div>
                  <h4 className="fw-bold mb-3 font-black">SEND MAIL</h4>
                  <p className="font-para mt-3">
                    Stay informed — we'll send key details to your inbox :
                    info@theshivgames.com
                  </p>
                  <button
                    className="btn call-now-btn text-white fw-semibold px-4 py-2 mt-5"
                    style={{ background: "#050708" }}
                  >
                    Send now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="callSection" className="container-fluid py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 pe-lg-5">
              <div className="mb-5">
                <h3
                  className="display-5 fw-bold mb-4 fs-sm-5 fs-md-3 fs-lg-2"
                  style={{ fontStyle: "rajdhani" }}
                >
                  ANY QUESTION? FEEL FREE TO{" "}
                  <span style={{ color: "#41C1EE" }}>CONTACT</span>
                  <br />
                  WITH US!
                </h3>
                <p className="font-para mb-4">
                  If you have any questions or need more information, please use
                  the form below to send us a message There were twelve rules in
                  all, and they specified that fights should be "a fair stand-up
                  boxing match" in a 24-foot-square or similar ring.
                </p>
              </div>

              <div className="d-flex align-items-center mb-4">
                <div className="me-3">
                  <div className="d-flex">
                    <img
                      src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face"
                      alt="Student"
                      className="rounded-circle me-1"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                      }}
                    />

                    <img
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face"
                      alt="Student"
                      className="rounded-circle me-1"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                      }}
                    />
                    <img
                      src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face"
                      alt="Student"
                      className="rounded-circle"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <div>
                  <span className="fw-bold text-dark">
                    Join over 4,000+ students
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <h5 className="fw-bold mb-3">FOLLOW US -</h5>
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <a
                    href="https://www.facebook.com/share/16TtByVBEd/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger fs-4 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "50px", height: "50px" }}
                  >
                    <i className="fab fa-facebook-f" />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/shiv-games-it-solutions/"
                    target="_blank"
                    className="btn btn-outline-danger fs-4 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "50px", height: "50px" }}
                  >
                    <i className="fa-brands fa-linkedin-in" />
                  </a>
                  <a
                    href="https://www.google.com/search?q=Shiv+Games+IT+Solutions+Private+Limited&rlz=1C1VDKB_enIN1115IN1115&oq=shiv+Games+IT+Solutions+Private+Limited&gs_lcrp=EgZjaHJvbWUqDggAEEUYJxg7GIAEGIoFMg4IABBFGCcYOxiABBiKBTINCAEQLhivARjHARiABDIHCAIQABiABDIICAMQABgWGB4yCggEEAAYgAQYogQyBggFEEUYPTIGCAYQRRg8MgYIBxBFGD3SAQgxNDk3ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger fs-4 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "50px", height: "50px" }}
                  >
                    <i className="fab fa-google-plus-g" />
                  </a>

                  <a
                    href="https://www.instagram.com/shivgames_/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger fs-4 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "50px", height: "50px" }}
                  >
                    <i className="fab fa-instagram" />
                  </a>

                  <a
                    href="https://wa.me/+919655022224"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger fs-4 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "50px", height: "50px" }}
                  >
                    <i className="fa-brands fa-whatsapp" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <Form className="p-4" onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <FaUser className="me-2" />
                        Full Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <FaEnvelope className="me-2" />
                        Email Address
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter email"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <FaPhone className="me-2" />
                        Phone Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter phone"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <FaWhatsapp className="me-2" />
                        WhatsApp
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleChange}
                        placeholder="WhatsApp"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <FaBuilding className="me-2" />
                        Company Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        placeholder="Company Name"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <IoMdBuild className="me-2" />
                        Company Service
                      </Form.Label>
                      <Form.Select
                        name="companyService"
                        value={formData.companyService}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Company Type</option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Partnership">Partnership</option>
                        <option value="Startup">Startup</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <MdOutlineMiscellaneousServices className="me-2" />
                        Type of Service looking for?
                      </Form.Label>
                      <Form.Select
                        name="serviceType"
                        value={formData.serviceType}
                        onChange={handleChange}
                      >
                        <option value="">Select a Service</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        <option value="Game">Game Development</option>
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        <option value="Website">Casino Api</option>
                        <option value="Website">Devops Solutions</option>
                        <option value="Website">It Support</option>
                        <option value="Website">Training Programs</option>
                        <option value="Website">Digital Marketing</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        <FaGlobe className="me-2" />
                        Country
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        placeholder="Country"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Your Message *"
                    required
                  />
                </Form.Group>

                <button type="submit" className="btn-red">
                  SUBMIT →
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.980020508895!2d80.19258987484027!3d12.909005587400637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d42a4a4febb%3A0x897fc6aac2adc841!2sShiv%20Games%20IT%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1751375649086!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps Location"
          />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactForm;
